import { Mail, Phone, MapPin, CalendarDays } from "lucide-react";
import { EMAIL, OFFICES, PHONES } from "@/lib/content";
import { PageHero } from "@/components/site/PageHero";
import { Eyebrow, Reveal } from "@/components/site/motion";
import { BookButton } from "@/components/site/Buttons";
import { EnquiryForm } from "./contact/EnquiryForm";

const Details = () => (
  <div className="space-y-4">
    <div className="rounded-3xl bg-[#082F24] grain relative text-[#FAF8F5] p-8">
      <CalendarDays className="h-8 w-8 text-[#D4AF37]" strokeWidth={1.4} />
      <p className="mt-6 font-display text-3xl">Prefer to talk it through?</p>
      <p className="mt-2 text-sm text-[#E8F3EE]/80 leading-relaxed">A free 30-minute conversation to understand your business, talk through what is getting in the way and explore where we can help.</p>
      <div className="mt-6"><BookButton testId="contact-book-consultation-btn" /></div>
    </div>
    <div className="rounded-3xl bg-white border border-[#0F5A47]/12 p-8 space-y-6 text-sm text-[#1A2520]">
      <a href={`mailto:${EMAIL}`} data-testid="contact-email-link" className="flex gap-3 items-center hover:text-[#0F5A47] break-all"><Mail className="h-5 w-5 shrink-0 text-[#0F5A47]" />{EMAIL}</a>
      <div className="flex gap-3"><Phone className="h-5 w-5 shrink-0 text-[#0F5A47]" />
        <ul className="space-y-1">{PHONES.map((p) => <li key={p.region}><a href={p.href} data-testid={`contact-phone-${p.region.toLowerCase()}`} className="hover:text-[#0F5A47]"><span className="font-mono-ega text-xs text-[#0F5A47] mr-2">{p.region}</span>{p.number}</a></li>)}</ul>
      </div>
      {OFFICES.map((o) => (
        <div key={o.region} className="flex gap-3"><MapPin className="h-5 w-5 shrink-0 text-[#0F5A47]" /><p data-testid={`contact-office-${o.region.toLowerCase().replaceAll(" ", "-")}`}><strong className="block">{o.label}</strong>{o.address}</p></div>
      ))}
    </div>
  </div>
);

export default function Contact() {
  return (
    <>
      <PageHero testId="contact-hero" eyebrow="Let’s start with you" lines={["What’s on", <em key="c" className="text-[#D4AF37]">your mind?</em>]} intro="You do not need perfect books or a fully formed plan to get in touch. Tell us what feels unclear, what is taking your time or what you want to do next. We will take it from there." />
      <section id="enquiry-form" data-testid="contact-form-section" className="bg-[#F3EFEA] py-20 lg:py-28 scroll-mt-28">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 grid gap-8 lg:grid-cols-12">
          <Reveal className="lg:col-span-7">
            <Eyebrow className="mb-6">Send an enquiry</Eyebrow>
            <EnquiryForm />
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5"><Details /></Reveal>
        </div>
      </section>
    </>
  );
}
